import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';

import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

const PasswordForgetPage = () => (
  <PasswordForgetForm />
);

const INITIAL_STATE = {
  email: '',
  error: null,
};

class PasswordForgetFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    const { email } = this.state;

    this.props.firebase
      .doPasswordReset(email)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
      })
      .catch(error => {
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, error } = this.state;

    const isInvalid = email === '';

    return (
      <div className="Container-box">
        <Card className="Card">
          <CardContent>
            <form className="Form-Container" onSubmit={this.onSubmit}>
              <TextField
                className="Text-Field"
                type="email"
                name="email"
                label="Email Address"
                value={this.state.email}
                onChange={this.onChange}
                autoComplete="email"
                autoFocus
                required
                margin="normal"
              />
              <Button variant="contained" size="medium" color="primary" disabled={isInvalid} className="Submit-Button" type="submit">
                Reset My Password
              </Button>

              {error && <p>{error.message}</p>}
            </form>
            <Link style={{ 'color': '#3e51b5', 'paddingTop': '3px', 'position': 'absolute', 'fontSize': 'small' }} to={ROUTES.SIGN_IN} className="menu-item"> Signin</Link>
          </CardContent>
        </Card>
      </div>
    );
  }
}

const PasswordForgetLink = () => (
  <CardContent className="text-center sign-desc">
    <Link to={ROUTES.PASSWORD_FORGET}>Forgot Password?</Link>
  </CardContent>
);

export default PasswordForgetPage;

const PasswordForgetForm = withFirebase(PasswordForgetFormBase);

export { PasswordForgetForm, PasswordForgetLink };
